export interface WebSocketConfig {
  /** Full WebSocket URL. Leave empty to derive from backend base URL. */
  url: string;

  /** Enable/disable websocket */
  enabled: boolean;

  /** WebSocket endpoint path */
  path: string;

  /** Delay before reconnecting */
  reconnectDelayMs: number;

  /** Maximum reconnect attempts */
  maxReconnectAttempts: number;

  /** STOMP heartbeat interval */
  heartbeatIntervalMs: number;
}

/** Topics */
export const HYGIENE_SUMMARY_TOPIC = '/topic/hygiene';
export const HYGIENE_UPDATE_DESTINATION = '/app/hygieneUpdate';
export const HYGIENE_BUILDING_IMAGE_LIST_TOPIC = '/topic/hygienBuildingImageList';
export const HYGIENE_BUILDING_LOCATIONS_TOPIC = '/topic/hygieneBuildingDetails';
export const HYGIENE_ZONE_INCHARGE_DETAILS_TOPIC = '/topic/zoneIncharge';
export const HYGIENE_ZONE_INCHARGE_UPDATE_DESTINATION = '/app/zoneInchargeDetails';

/** @deprecated Use HYGIENE_BUILDING_LOCATIONS_TOPIC */
export const HYGIENE_BUILDING_DETAILS_TOPIC =
  HYGIENE_BUILDING_LOCATIONS_TOPIC;

/** Default WebSocket configuration */
export const DEFAULT_WEBSOCKET_CONFIG: WebSocketConfig = {
  // Leave empty to derive from environment.apiUrl
  url: '',

  enabled: true,

  // Backend SockJS endpoint
  path: '/ws-sockjs',

  reconnectDelayMs: 5000,
  maxReconnectAttempts: 10,
  heartbeatIntervalMs: 30000,
};